module.exports = __webpack_public_path__ + "img/xingtu.c5f9ffd2.png";